<template>
  <div class="main-container">
    <!-- Navigation -->
    <div class="sidebar-widget" :class="{
      minimized: $store.state.side_bar,
      phone_minimized: phone_menu_minimized,
    }" ref="sidebar_widget" v-closable="{ exclude: ['sidebar_widget'], handler: 'hideAllDropDown' }">
      <div class="profile-widget">
        <div class="btn-menu-logo">
          <img class="profile-logo" v-if="$getLoggedUser().manager_picture" :src="$fullUrl('images/profiles/' + $getLoggedUser().manager_picture)
            " />
          <img class="profile-logo" v-else src="@/assets/avatar.png" />
        </div>
        <h5>{{ $getLoggedUser().manager_name | validate }}</h5>
        <p>Instructor</p>
      </div>
      <div class="menu-list" :class="{ 'on-dropdown-menu-open': on_dropdown_menu_open }">
        <ul>
          <template v-for="(item, index) in routes">
            <li class="item" v-if="item.active" :key="index" :class="{
              active:
                $route.name == item.name ||
                whenRouterEqual(item.name),
              wizard_active: $store.state.wizard_active_menu == item.name,
              divider: item.divider,
              dropdown_active: item.dropdown_active,
              show_line: item.showSplitLine
            }" :id="`menu-item-${index}`">
              <div class="link" @click="navigateTo(item)">
                <img class="icon" v-if="$route.name == item.name ||
                  whenRouterEqual(item.name)
                " :style="{ width: item.img_width }" :src="require('@/assets/admin-icon/menu/' + item.icon_active)" />
                <img v-else class="icon" :style="{ width: item.img_width }"
                  :src="require('@/assets/admin-icon/menu/' + item.icon)" />

                <span class="text-dropdown">
                  <span class="text">{{ item.label | validate }}</span>
                  <div class="drop-icon" v-if="item.dropdown">
                    <img width="11" v-if="item.dropdown_active" src="@/assets/admin-icon/dropdown_active.svg" />
                    <img v-else width="7" src="@/assets/admin-icon/dropdown_nonactive.svg" />
                  </div>
                </span>
              </div>
              <div class="dropdown" v-if="item.dropdown_active && item.dropdown">
                <div class="dropdown-link" v-for="(val, index) in item.dropdown" :key="index" :class="{
                  active:
                    ($route.name == item.name && $route.params.type == val.name) ||
                    ($route.name == val.name)
                }" @click="navigateDropDownTo(item, val)">
                  {{ val.label | validate }}
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <div class="sidebar-footer">
        <button class="btn-help" @click="goToHelpPage()">
          <img src="@/assets/icons/Info.svg" />
          <span v-if="!$store.state.side_bar">Help center</span>
        </button>
      </div>
    </div>
    <div class="body-container" :class="{
      minimized: $store.state.side_bar,
      phone_minimized: phone_menu_minimized,
    }">
      <div v-show="getLoader.isLoading" class="loading-container">
        <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="getLoader.isLoading"
          :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
      </div>
      <router-view>
        <slot> </slot>
      </router-view>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["getLoader"]),
  },
  data: () => ({
    show_settinds_dropdown: false,
    phone_menu_minimized: true,
    routes: [
      {
        name: "search",
        label: "Search",
        value: "search",
        icon: "search.svg",
        icon_active: "search_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: true,
        active: false
      },
      {
        name: "calendar",
        label: "Calendar",
        icon: "calendar.svg",
        value: "calendar",
        icon_active: "calendar-active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "accounts",
        label: "Accounts",
        value: "accounts",
        icon: "accounts.svg",
        icon_active: "accounts_active.svg",
        dropdown_active: false,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "task",
        label: "Task",
        value: "tasks",
        icon: "tasks.svg",
        icon_active: "tasks_active.svg",
        dropdown_active: false,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "leads",
        label: "Leads",
        value: "leads",
        icon: "leads.svg",
        icon_active: "leads_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "candidates",
        label: "Candidates",
        value: "candidates",
        icon: "candidates.svg",
        icon_active: "candidates_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "assignment",
        label: "LIA",
        icon: "internship.svg",
        value: "internship",
        icon_active: "internship_active.svg",
        dropdown_active: false,
        img_width: "24px",
        showSplitLine: true,
        active: false
      },
      {
        name: "dashboard",
        label: "Dashboard",
        value: "dashboard",
        icon: "dashboard.svg",
        icon_active: "dashboard_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "instructor",
        initiaPath:
          "/instructor/invitation-profile-build/invitation-to-build-profile",
        label: "LIA Process/Instructor",
        value: "instructor",
        icon: "instructor.svg",
        icon_active: "instructor_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "resumes",
        label: "Resumes",
        value: "resumes",
        icon: "resumes.svg",
        icon_active: "resumes_active.svg",
        dropdown_active: false,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "organization",
        initiaPath: "/school/students",
        label: "School",
        value: "school",
        icon: "school.svg",
        icon_active: "school_active.svg",
        dropdown_active: false,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "communications",
        label: "Communications",
        value: "communication",
        icon: "communication.svg",
        icon_active: "communication-active.svg",
        dropdown_active: false,
        dropdown: [
          {
            name: "emails",
            label: "Email",
          },
          {
            name: "notifications",
            label: "Notification",
          },
          {
            name: "questionnaires",
            label: "Questionnaires",
          }
        ],
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "reports",
        label: "Reports",
        value: "reports",
        icon: "reports.svg",
        icon_active: "reports_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        showSplitLine: false,
        active: false
      },
      {
        name: "alumni",
        label: "Alumni",
        value: "alumni",
        icon: "alumni.svg",
        icon_active: "alumni_active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "20px",
        showSplitLine: false,
        active: false
      },
      // {
      //   name: "pitch",
      //   label: "Pitches",
      //   value: "pitches",
      //   icon: "pitches.svg",
      //   icon_active: "pitches_active.svg",
      //   dropdown_active: false,
      //   img_width: "24px",,
      // active: false
      // },
      // {
      //   name: "newsletter",
      //   label: "News Letter & Emails",
      //   icon: "alumni.svg",
      //   dropdown_active: false,
      //   dropdown: null,
      //   img_width: "20px",
      //  active: false
      // },
      {
        name: "matrix",
        label: "Matrix",
        value: "matrix",
        icon: "pie-chart.svg",
        icon_active: "pie-chart-active.svg",
        dropdown_active: false,
        dropdown: null,
        img_width: "24px",
        active: false
      }
    ],
    on_dropdown_menu_open: false,
    featuresData: [],
    isLoadingFeatures: false
  }),
  created() {
    this.loadSubscriptionData();
  },
  mounted() {
    let vm = this;
    window.addEventListener("message", (event) => {
      const message = event.data.message;
      switch (message) {
        case "toggleNavigation":
          vm.toggleNavigation();
          break;
      }
    });

  },
  watch: {},
  methods: {
    loadSubscriptionData() {
      // Load subscription data from API
      let vm = this;
      vm.isLoadingFeatures = true;
      vm.$store.dispatch("GET_SUBSCRIPTION_FEATURES_DATA", {
        features: vm.routes.map(feature => feature.value)
      }).then(response => {
        vm.isLoadingFeatures = false;
        vm.featuresData = response.data;
        // Update features array with subscription data
        if (vm.featuresData && Array.isArray(vm.featuresData)) {
          vm.featuresData.forEach(subscriptionFeature => {
            const featureIndex = vm.routes.findIndex(f => f.value === subscriptionFeature.feature);
            if (featureIndex !== -1) {
              vm.routes[featureIndex].active = subscriptionFeature.active;
            }
          });
        }

      }).catch(error => {
        console.error(error);
      });
    },
    goToHelpPage() {
      // open new tab
      window.open("https://wiki.meritios.com/en/instructor", "_blank");
    },
    toggleNavigation() {
      let vm = this;
      vm.$store.state.side_bar = !vm.$store.state.side_bar;
      vm.phone_menu_minimized = !vm.phone_menu_minimized;
    },
    hideAllDropDown() {
      let vm = this;

      if (vm.$store.state.side_bar) {
        vm.routes.map((item) => {
          item.dropdown_active = false;
        });
      }
    },
    navigateDropDownTo(item, val) {
      let vm = this;
      vm.$router
        .push({ name: val.name })
        .catch((error) => { });
      if (vm.$store.state.side_bar) {
        item.dropdown_active = false;
        vm.on_dropdown_menu_open = false;
      } else {
        item.dropdown_active = true;
      }
    },
    navigateTo(item) {
      let vm = this;
      vm.phone_menu_minimized = true;
      if (item.dropdown) {
        if (!item.dropdown_active) {
          vm.routes.map((item) => {
            item.dropdown_active = false;
          });
          item.dropdown_active = true;
          vm.on_dropdown_menu_open = true;
        } else {
          item.dropdown_active = false;
          vm.on_dropdown_menu_open = false;
        }
      } else {
        vm.routes.map((item) => {
          item.dropdown_active = false;
        });
        if (item.initiaPath) {
          vm.$router.push({ path: item.initiaPath }).catch((error) => { });
        } else {
          vm.$router.push({ name: item.name }).catch((error) => { });
        }
      }
    },
    hideMenu() {
      let vm = this;
      vm.show_settinds_dropdown = false;
    },
    logOut() {
      let vm = this;
      vm.$store.dispatch("AUTH_LOGOUT");
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    whenRouterEqual(label) {
      let vm = this;
      if (label == "organization") {
        if (vm.$route.name == "manage_consultant") {
          return true;
        }
        if (vm.$route.name == "view-team") {
          return true;
        }
      } else if (label == "accounts") {
        if (vm.$route.name == "account-view") {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.main-container {
  .sidebar-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 193px;
    background: linear-gradient(186deg,
        rgba(27, 165, 164, 1) 0%,
        rgba(24, 133, 173, 1) 100%);
    z-index: 99999;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    transition: 600ms ease-in-out;
    align-items: flex-start;
    transition: 600ms ease-in-out;

    * {
      transition: 600ms ease-in-out;
    }

    @media (min-width: 300px) and (max-width: 650px) {
      right: 0px;
      left: unset;
    }

    &.minimized {
      padding-top: 0px;
      width: 60px;
      z-index: 9999999999999 !important;

      .profile-widget {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 47px;
        padding-top: 6px;
        padding: 0px 20px;

        @media (min-width: 300px) and (max-width: 650px) {
          display: none;
        }

        .btn-menu-logo {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          position: relative;

          .btn-menu {
            background: transparent;
            border: none;
            position: unset;
            left: unset;
            margin-bottom: 14px;
          }

          .profile-logo {
            width: 30px;
            height: 30px;
            object-fit: cover;
            border-radius: 50%;
          }
        }

        h5 {
          margin-bottom: 0px;
          margin-top: 6px;
          font-size: 18px;
          color: #fff;
          display: none;
          text-align: center;
        }

        p {
          margin-top: 2px;
          margin-bottom: 0px;
          width: 200px;
          text-align: center;
          color: #ddd;
          display: none;
        }
      }

      .menu-list {
        height: calc(100% - 40px);
        overflow-y: auto;

        // -ms-overflow-style: none; /* IE and Edge */
        // scrollbar-width: none; /* Firefox */
        // &::-webkit-scrollbar {
        //   display: none;
        // }
        &.on-dropdown-menu-open {
          overflow-y: unset;
        }

        ul {
          list-style: none;
          padding-left: 0px;

          li.item {
            padding: 2px 0px;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            position: relative;

            &.wizard_active {
              animation: blinker 1s linear infinite;
            }

            .link {
              display: flex;
              align-items: center;
              padding: 15px 20px;



              img.icon {
                margin-right: 20px;
                width: 16px;
              }

              .text-dropdown {
                span.text {
                  color: #fff;
                  width: 85%;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  display: none;
                }

                .drop-icon {
                  margin-left: 5px;
                  margin-top: 2px;
                }
              }
            }

            .dropdown {
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              position: absolute;
              z-index: 99999999999999999999999999999;
              background: #147489;
              left: 60px;
              width: 200px;

              .dropdown-link {
                padding: 15px 0px;
                color: #fff;
                padding-left: 15px !important;

                &.active {
                  color: #0884af;
                  background: #fff;
                }

                &:hover {
                  color: #0884af;
                  background: #fff;
                }
              }
            }

            &.active {
              background: #fff;

              span {
                color: #0884af;
              }
            }

            &:hover {
              background: rgba(255, 255, 255, 0.149);

              span {
                color: #fff !important;
              }
            }
          }

          li.divider {
            margin-bottom: 30px;
          }
        }
      }
    }

    &.phone_minimized {
      @media (min-width: 300px) and (max-width: 650px) {
        right: -182px;
      }
    }

    .profile-widget {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;
      padding-left: 0px;
      padding-top: 2px;
      width: 100%;

      @media (min-width: 300px) and (max-width: 650px) {
        display: none;
      }

      .btn-menu-logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        .profile-logo {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
        }
      }

      h5 {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        margin: 0px;
        margin-top: 8px;
      }

      p {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 19px;
        color: rgba(255, 255, 255, 0.4);
        margin: 0px 0px;
      }
    }

    .menu-list {
      height: calc(100% - 135px);
      width: 100%;
      overflow-y: auto;

      @media (min-width: 300px) and (max-width: 650px) {
        height: calc(100% - 0px);
      }

      ul {
        list-style: none;
        padding-left: 0px;
        margin-top: 0px;

        li.item {
          display: flex;
          flex-direction: column;
          cursor: pointer;
          min-height: 35px;
          justify-content: center;

          &.wizard_active {
            animation: blinker 1s linear infinite;
          }

          &.dropdown_active {
            padding-top: 10px;
          }

          &.show_line {
            border-bottom: 1px solid rgb(132, 215, 215);
          }

          .link {
            display: flex;
            align-items: center;
            padding: 0px 22px;
            height: 100%;
            padding-right: 0px;

            img.icon {
              margin-right: 11px;
              width: 15px !important;
            }

            .text-dropdown {
              width: 76%;
              display: flex;
              align-items: center;

              span.text {
                font-family: "Nunito";
                font-style: normal;
                font-weight: 400;
                font-size: 11px;
                line-height: 22px;
                color: #ffffff;
                width: 85%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .drop-icon {
                margin-left: 5px;
                margin-top: 2px;
              }
            }
          }

          .dropdown {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            background: #147489;
            width: 100%;

            .dropdown-link {
              padding: 15px 0px;
              color: #fff;
              padding-left: 48px !important;

              &.active {
                color: #0884af;
                background: #fff;
              }

              &:hover {
                color: #0884af;
                background: #fff;
              }
            }
          }

          &:hover {
            background: rgba(255, 255, 255, 0.149);

            span {
              color: #fff !important;
            }
          }

          &.active {
            background: #fff;

            span {
              color: #0884af !important;
            }

            &:hover {
              background: #fff;

              span {
                color: #0884af !important;
              }
            }
          }
        }

        li.divider {
          margin-bottom: 30px;
        }
      }
    }

    .sidebar-footer {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #1ea0d6;

      .btn-help {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        padding: 0px;

        img {
          margin-right: 14px;
          width: 15px !important;
        }

        span {
          font-family: "Nunito";
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }

  .body-container {
    position: fixed;
    left: 193px;
    right: 0px;
    bottom: 0px;
    top: 0px;
    display: flex;
    flex-direction: column;
    z-index: 999999995;
    transition: 600ms ease-in-out;

    @media (min-width: 300px) and (max-width: 650px) {
      left: 0px;
    }

    .loading-container {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 9999999999;
      background: rgba($color: #fff, $alpha: 1);
    }

    &.minimized {
      left: 60px;
      transition: 600ms ease-in-out;
    }

    &.phone_minimized {
      @media (min-width: 300px) and (max-width: 650px) {
        left: 0px;
      }
    }
  }
}
</style>
